import axios from 'axios';

export const lineGroupPresentationApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/line-group-presentation`,
    headers: {
        'Content-Type': 'application/json'
    }
})